import { checkIntegrity, forkDocument } from '@orbit-mind/domain';
import { openJournal } from '@orbit-mind/offline-engine';
import { unwrap } from '@orbit-mind/shared-types';
import { openMap } from './engine';
import { randomIds, systemClock } from './environment';
import { renameMap } from './intents';
export async function readLibraryDocument(storage, mapId) {
    const opened = unwrap(await openJournal({ storage, mapId }));
    if (opened.outcome !== 'clean')
        throw new Error('Abra o mapa para verificar a recuperação antes de continuar.');
    return opened.document;
}
export async function renameLibraryMap(storage, catalog, mapId, authorId, title) {
    if (!title.trim())
        throw new Error('Informe um título.');
    const opened = unwrap(await openMap({
        storage,
        mapId,
        environment: { ids: randomIds(), clock: systemClock(), authorId },
        onCheckpoint: async (document) => {
            unwrap(await catalog.save(document));
        },
    }));
    if (opened.outcome !== 'clean')
        throw new Error('Abra o mapa para verificar a recuperação antes de renomear.');
    try {
        unwrap(await opened.engine.dispatch(renameMap(opened.engine.context(), title.trim().slice(0, 200))));
    }
    finally {
        unwrap(await opened.engine.close());
    }
}
export async function duplicateLibraryMap(storage, catalog, mapId, copyFiles, recovered) {
    const source = recovered ?? (await readLibraryDocument(storage, mapId));
    if (source.map.id !== mapId || checkIntegrity(source).length > 0)
        throw new Error('The recovered document needs an intact checkpoint before it can be copied.');
    const at = Date.now();
    const copy = forkDocument(source, `map_${randomIds().nodeId()}`, `${source.map.title} — cópia`, at);
    await copyFiles(copy, source);
    unwrap(await catalog.create(copy.document, at));
    return copy.document.map.id;
}
//# sourceMappingURL=library-actions.js.map